
export const general = {
  siteName: "streamclips.org"
}

export const urls = {
    clipSearch: `/api/clips/`,
    clip: `/api/clip/`,
    homepageView: `/api/homepage_view/`,
    chat: `/api/chats/`,
    insClips: `/api/insclip/`

  };
